import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  const classes = clsx(inputs);
  // Separate custom typography classes from standard Tailwind classes
  const classArray = classes.split(" ");
  const customClasses = classArray.filter((cls) =>
    /^text-(body|heading)-/.test(cls),
  );
  const tailwindClasses = classArray.filter(
    (cls) => !/^text-(body|heading)-/.test(cls),
  );

  // Merge standard Tailwind classes, then append custom classes
  return [twMerge(tailwindClasses.join(" ")), ...customClasses]
    .filter(Boolean)
    .join(" ");
}
